import { useMemo, useState } from 'react';
import './Header.css';
import logo from '../assets/images/TA.jpg';

const navItems = [
  { href: '#accueil', label: 'Accueil' },
  { href: '#apropos', label: 'À propos' },
  { href: '#competences', label: 'Compétences' },
  { href: '#contact', label: 'Contact' },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const initials = useMemo(() => 'TA', []);

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a className="brand" href="#accueil" aria-label="Retour à l'accueil">
          <span className="brand__mark">
            <img src={logo} alt="Logo Thomas Amand" />
          </span>
          <span className="brand__text">
            <strong>Thomas Amand</strong>
            <span>Développeur & Analyste programmeur</span>
          </span>
        </a>

        <button
          type="button"
          className="menu-button"
          aria-expanded={menuOpen}
          aria-label="Ouvrir le menu"
          onClick={() => setMenuOpen((value) => !value)}
        >
          <span />
          <span />
        </button>

        <nav className={`site-nav ${menuOpen ? 'site-nav--open' : ''}`}>
          {navItems.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setMenuOpen(false)}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Header;
